import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { map, isEmpty } from 'lodash';

import { sendersDataByDomain } from '../sender-details/selectors/sender-details-selectors';
import { rightPaneTitleSelector } from '../common/selectors/right-pane-selectors';
import { updateRecognizedSendersForADomain } from '../common/actions/recognized-senders-action-creators';

import VerificationBySenderModal from './verification-by-sender-modal';

export class VerificationBySenderModalContainer extends Component{
    constructor( props ){
        super( props );

        this.state = {
            updatedSendersMap: {}
        };
    }

    updateSenderStatus = ( senderId ) => ( event ) => {
        this.setState( {
            updatedSendersMap: {
                ...this.state.updatedSendersMap,
                [senderId]: event.target.value
            }
        } );
    };

    handleSave = () => {
        const { updateRecognizedSendersForADomain, domain } = this.props;
        const { updatedSendersMap } = this.state;
        updateRecognizedSendersForADomain( domain,
            map( updatedSendersMap, ( status, senderId ) => ( { senderId, status } ) ) )
            .then( () => this.setState( {
                updatedSendersMap: {}
            } ) );
    }

    handleCancel = () => {
        this.setState( {
            updatedSendersMap: {}
        } );
        this.props.onClose();
    }

    render(){
        const { senders, domain, open } = this.props;
        const { updatedSendersMap } = this.state;

        const temporaryUpdatedSenders = senders.map( sender => {
            if( this.state.updatedSendersMap[sender.id] ){
                return {
                    ...sender,
                    status: this.state.updatedSendersMap[sender.id]
                };
            }
            else{
                return sender;
            }
        } );

        return (
            <VerificationBySenderModal
                senders={temporaryUpdatedSenders}
                editMode={true}
                domain={domain}
                open={open}
                onClose={this.handleCancel}
                onSave={this.handleSave}
                onSelection={this.updateSenderStatus}
                saveDisabled={isEmpty( updatedSendersMap )}
            />
        );
    }
};

/* istanbul ignore next */
function mapStateToProps( state ){
    return {
        domain: rightPaneTitleSelector( state ),
        senders: sendersDataByDomain( state ),
    };
}

VerificationBySenderModalContainer.propTypes = {
    domain: PropTypes.string.isRequired,
    onClose: PropTypes.func,
    open: PropTypes.bool.isRequired,
    senders: PropTypes.array.isRequired,
    updateRecognizedSendersForADomain: PropTypes.func.isRequired,
};

export default connect(
    mapStateToProps,
    { updateRecognizedSendersForADomain }
)( VerificationBySenderModalContainer );
